import { environment } from 'src/environments/environment';

interface OAuthConfig {
  redirectTo?: string;
}

export const SIGNIN_ACTION = 'signin';
export const ACCEPT_INVITATION_ACTION = 'accept';
export const RESET_ACTION = 'reset';
export const DESIGNATED_CONTACTS_ACTION = 'signup';
export const APP_SPECIFIC_REDIRECT_URI = 'com.lyfeplum://app';

/**
 * Configuration object for OAuth authentication.
 *
 * @constant
 * @type {OAuthConfig}
 *
 * @property {string} redirectTo - The URL to redirect to after authentication,
 * constructed using the current window location origin and a predefined router path.
 */
export const oauthConfig: OAuthConfig = {
  redirectTo: `${window.location.origin}/login?action=${SIGNIN_ACTION}`,
};
export const CAPACITOR_REDIRECT_TO = `${APP_SPECIFIC_REDIRECT_URI}/login?action=${SIGNIN_ACTION}`;

/**
 * Configuration object for resetting the password in OAuth authentication.
 *
 * @constant
 * @type {OAuthConfig}
 *
 * @property {string} redirectTo - The URL to redirect to after resetting the password,
 * constructed using the current window location origin and a predefined router path.
 */
export const resetPasswordConfig: OAuthConfig = {
  redirectTo: `${window.location.origin}/update-password?action=${RESET_ACTION}`,
};
export const CAPACITOR_RESET_PASSWORD_REDIRECT_TO = `${APP_SPECIFIC_REDIRECT_URI}/update-password?action=${RESET_ACTION}`;

/**
 * Configuration object for designated contacts in OAuth authentication.
 *
 * @constant
 * @type {OAuthConfig}
 *
 * @property {string} redirectTo - The URL to redirect to for designated contacts,
 * constructed using the current window location origin and a predefined router path.
 */
export const designatedContactsConfig: OAuthConfig = {
  redirectTo: `${window.location.origin}/sign-up/sign-up-with-email?action=${DESIGNATED_CONTACTS_ACTION}`,
};
export const CAPACITOR_DESIGNATED_CONTACTS_REDIRECT_TO = `${environment.appRedirectUrl}/sign-up/sign-up-with-email?action=${DESIGNATED_CONTACTS_ACTION}`;
